// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Carbonometro_TransactionsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /api/public/carbonometro/transactions.
 *
 * - `fromTime`: ISO-8601 instant with 'Z' or a numeric offset — the INCLUSIVE
 *   lower bound on `addedTime`. Anything else (a date only, 'yesterday', a
 *   bare local datetime) is a 400: the consumer paginates by echoing the last
 *   `addedTime` back, so a lenient parse here would silently shift the window.
 * - `pageSize`: optional, default 500; < 1 or not an integer is a 400. Values
 *   ABOVE 500 are not an error — the controller clamps them (shape stays pure).
 *
 * Strict JSON types: "500" (a string) is refused, 500 (a number) is accepted.
 */
import { registerContract } from './validate'

export interface Carbonometro_TransactionsInput {
fromTime: string
pageSize?: number
}

registerContract('Carbonometro_TransactionsInput', {
  fromTime: { type: 'string',  required: true },
  pageSize: { type: 'number',  required: false },
})
